import React from 'react';
import { Star, CheckCircle2 } from 'lucide-react';

const Testimonials = ({ siteData }) => {
  if (!siteData?.testimonials) return null;

  return (
    <section id="testimonials" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center space-y-4 mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900">
            {siteData.testimonials.title.split(' ').map((word, i) =>
              word.toLowerCase().includes('stories') || word.toLowerCase().includes('patient') ? <span key={i} className="text-red-600">{word} </span> : word + ' '
            )}
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            {siteData.testimonials.subtitle}
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-8 max-w-7xl mx-auto">
          {siteData.testimonials.list.map((testimonial) => (
            <div key={testimonial.id} className="bg-gradient-to-br from-white to-red-50 rounded-2xl p-8 shadow-xl border-2 border-red-100 hover:shadow-2xl transition-all">
              <div className="flex items-start space-x-4 mb-6">
                <img src={testimonial.image} alt={testimonial.name} className="w-20 h-20 rounded-full border-4 border-white shadow-lg object-cover" />
                <div className="flex-1">
                  <div className="flex items-start justify-between">
                    <div>
                      <h4 className="text-xl font-bold text-gray-900">{testimonial.name}, {testimonial.age}</h4>
                      <p className="text-sm text-gray-600">{testimonial.country}</p>
                    </div>
                    {testimonial.verified && (
                      <div className="flex items-center space-x-1 bg-green-100 px-3 py-1 rounded-full">
                        <CheckCircle2 className="w-4 h-4 text-green-600" />
                        <span className="text-xs text-green-700 font-bold">{siteData.testimonials.labels?.verifiedText || 'Verified'}</span>
                      </div>
                    )}
                  </div>
                  <div className="flex items-center space-x-1 mt-2">
                    {[...Array(testimonial.rating)].map((_, i) => (
                      <Star key={i} className="w-4 h-4 fill-yellow-400 text-yellow-400" />
                    ))}
                  </div>
                </div>
              </div>

              <div className="space-y-3 mb-6">
                <div className="flex items-center justify-between p-3 bg-white rounded-xl border border-red-50">
                  <div>
                    <p className="text-xs text-gray-500">{siteData.testimonials.labels?.conditionLabel || 'Condition'}</p>
                    <p className="font-bold text-gray-900">{testimonial.condition}</p>
                  </div>
                  <div className="w-px h-8 bg-red-100"></div>
                  <div>
                    <p className="text-xs text-gray-500">{siteData.testimonials.labels?.medicationLabel || 'Medication'}</p>
                    <p className="font-bold text-gray-900">{testimonial.medication}</p>
                  </div>
                </div>
              </div>

              <p className="text-gray-700 leading-relaxed italic mb-6">
                "{testimonial.testimonial}"
              </p>

              <div className="flex items-center justify-between pt-6 border-t-2 border-red-200">
                <div>
                  <p className="text-sm text-gray-600">{siteData.testimonials.labels?.totalSavingsLabel || 'Total Savings'}</p>
                  <p className="text-3xl font-bold text-green-600">{testimonial.savings}</p>
                </div>
                <div className="text-right">
                  <p className="text-sm text-gray-600">{siteData.testimonials.labels?.treatmentDurationLabel || 'Treatment Duration'}</p>
                  <p className="font-bold text-gray-900">{testimonial.treatmentDuration}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
